module.exports = __webpack_public_path__ + "57bf7a01e8305d78ddf827ccb67ffa3a.glb";